(function() {
    // Najde tlačítko "NAJDI SVÉ PLEMENO"
    const breedButton = document.querySelector('.image-banner__button[href*="/collections/moje-plemeno"]');
  
    // Přidání event listeneru pro tlačítko
    if (breedButton) {
        breedButton.addEventListener('click', (e) => {
            e.preventDefault();
            
            // Najdeme details element v header
            const searchModal = document.querySelector('details-modal details');
            
            if (searchModal) {
                // Otevřeme modal přidáním atributu open
                searchModal.setAttribute('open', '');
                
                // Najdeme a aktivujeme search-form element
                const searchForm = searchModal.querySelector('search-form');
                if (searchForm) {
                    // Zajistíme, že je search-form inicializován
                    if (!searchForm.initialized) {
                        customElements.upgrade(searchForm);
                    }
                }
                
                // Zaměříme search input
                const searchInput = searchModal.querySelector('input[type="search"]');
                if (searchInput) {
                    searchInput.focus();
                    
                    // Vyvoláme událost input pro aktivaci predictive search
                    const inputEvent = new Event('input', {
                        bubbles: true,
                        cancelable: true
                    });
                    searchInput.dispatchEvent(inputEvent);
                }
            }
        });
    }

    // Event listener pro ESC
    document.addEventListener('keyup', (e) => {
        if (e.key === 'Escape') {
            const searchModal = document.querySelector('details-modal details[open]');
            if (searchModal) {
                searchModal.removeAttribute('open');
            }
        }
    });

    // Event listener pro klik mimo modal
    document.addEventListener('click', (e) => {
        const searchModal = document.querySelector('details-modal details[open]');
        if (searchModal && 
            !searchModal.contains(e.target) && 
            !e.target.closest('.image-banner__button')) {
            searchModal.removeAttribute('open');
        }
    });
})();